import React from "react";
import UploadSection from "./UploadSection";

type UploadStage = "idle" | "uploading" | "uploaded" | "error";

interface Props {
  file: File | null;
  onChange: (file: File | null) => void;
  uploadStage: UploadStage;
  progress: number;
  onCancel: () => void;
  onDelete?: () => void;
  isEditingPublished?: boolean;
  isInvalid?: boolean;
}

const HeroImageUpload: React.FC<Props> = ({
  file,
  onChange,
  uploadStage,
  progress,
  onCancel,
  onDelete,
  isEditingPublished,
  isInvalid = false,
}) => {
  return (
    <UploadSection
      title="Hero image*"
      description="This image will be used as the main image for your title"
      formats="JPEG, PNG (1920x1080 min.)"
      onFileChange={onChange}
      currentFile={file}
      accept=".jpg,.jpeg,.png"
      uploadStage={uploadStage}
      progress={progress}
      onCancel={onCancel}
      onDelete={onDelete}
      isEditingPublished={isEditingPublished}
      isInvalid={isInvalid}
    />
  );
};

export default HeroImageUpload;
